import { useQuery } from '@tanstack/react-query'
import { fetchTrekPricing, type TrekPricingRow } from '@/services/trekPricing'

/**
 * React Query hook for compta-sourced trek pricing.
 *
 * - 5-minute stale time: prices don't change often, but a fresh tab picks up
 *   a compta price update within 5 minutes max.
 * - Returns `undefined` on first load and on failure (no `data` yet); callers
 *   should fall back to the Enduro DB `price_usd` until `data` is populated.
 */
export const useTrekPricing = () => {
  return useQuery<TrekPricingRow[]>(
    ['compta', 'trek-pricing'],
    fetchTrekPricing,
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  )
}
